const convertFileListToArray = (fileList?: FileList): File[] => {
  if (!fileList) {
    return [];
  }

  return Array.from(fileList);
};

export default convertFileListToArray;
